import { Box, Button, Typography } from "@mui/material"
import apiManagerRoom from "api/manager-meeting"
import apiManagerUser from "api/manager-users"
import { ReactComponent as IconCopy } from 'assets/svg/IconCopy.svg'
import { DIALOG_ID } from "components/Dialog/constant"
import { TooltipCC } from "components/common"
import { IconJoinMeeting } from "components/common/IconCommon"
import { DOMAIN_MEETING } from "constants/api"
import { BACKGROUNDCOLOR_MEETING_EVENT, BORDER_COLOR_RIGHT_MEETING_EVENT, COLOR_MEETING_EVENT, COLOR_MEETING_GRID_EVENT, LABEL_STATUS_MEETING_EVENT, ROLE_IN_ROOM, STATUS_MEETING_EVENT, TYPE_CONVERT_MEETING } from "constants/common"
import { TOAST_DEFAULT } from "constants/toast"
import { HEIGHT_COMPONENTS } from "constants/ui.contants"
import moment from "moment"
import theme from "theme"
import { getCurrentColorSystem, isDefaultColorSystem } from 'utils/functions'
import { goToRoomMeeting, joinRoomByRoomId } from "utils/functions/common"
import { copyToClipboard, setCloseDialogCC, setOpenDialogCC, toastError, toastSuccess, toastWarning } from "utils/helpers"
/**
 * anhnt653 20230915
 * Handle render header
 * Xử lý render header events ở các dạng danh sách || tuần || ngày
 * @param {*} args 
 * @param {*} moment 
 * @returns 
 */
export function renderHeader(args, moment) {
    const { date, isToday } = args
    const isListType = args.view.type.includes('list')
    return (
        <>
            {
                isListType ? <></> : (
                    <div className='header-day'>
                        <span className={`header-day-m ${isToday ? 'header-day-today' : ''}`}>{moment(date).format('DD/MM')}</span>
                        <span className='header-day-d' style={{ textTransform: 'capitalize' }}>{moment(date).format('dddd')}</span>
                    </div>
                )
            }
        </>
    )
}
const TitleMeetingEvent = ({ status, title, handleClickViewDetail, handleCopyRoomLink, roomId, t }) => {
    return (
        <Typography
            sx={{
                display: "flex",
                flex: 1,
                marginLeft: { xs: `0`, xl: `${theme.spacing(2)}` }
            }}>
            <Typography fontWeight={700} sx={{ cursor: 'pointer', textDecoration: status === STATUS_MEETING_EVENT.CANCELED ? 'line-through' : 'unset', }} onClick={handleClickViewDetail}>
                {title}
            </Typography>
            <TooltipCC title={t('tooltip.copyUrl')}>
                <span
                    tabIndex={0}
                    className="feature-copy"
                    onClick={() =>
                        handleCopyRoomLink(
                            `${DOMAIN_MEETING}/${roomId}`,
                        )
                    }
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleCopyRoomLink(
                                `${DOMAIN_MEETING}/${roomId}`,
                            );
                        }
                    }}
                    role="button"
                >
                        <IconCopy />
                </span>
            </TooltipCC>

        </Typography>
    )
}

/**
 * anhnt653 20230915
 * Handle render event
 * Xử lý render events ở các dạng danh sách || tuần || ngày
 * @param {*} args 
 * @param {*} moment 
 * @returns 
 */
export function renderEvent(args, moment, handleOpenDetailRoom, t, dispatch, navigate, totalMeeting) {
    const { roomId, title, start, end, status, tsStart, parentRoomId, realRoomId, isPeriod, role, endTimeCalendar, isInstant } = args.event._def.extendedProps
    const { isToday } = args
    const isShortTime = moment(end).diff(moment(start), 'minutes') <= 30
    const isListType = args.view.type.includes('list')
    
    const handleCopyRoomLink = async (copyMe) => {
        try {
            await navigator.clipboard.writeText(copyMe);
            toastSuccess(t('breadcrumb.copySuccess'));
        } catch (err) {
            console.log('ERROR: ', err);
        }
    };

    const handleClickViewDetail = () => {
        handleOpenDetailRoom(realRoomId || roomId, parentRoomId, tsStart, status);
    }

    const endRoom = (data) => {
        return apiManagerRoom.updateEndRoom(data);
    };

    const actionEndRoom = (roomId, parentRoomId) => {
        endRoom({ roomId: roomId, parentRoomId: parentRoomId})
        .then((r) => { 
            if (r.status === 200 && r.data?.type === 'progress') {
                toastSuccess(t('toast.endMeetSuccess'));
            } else if(r.status === 200 && r.data?.type === 'end'){
                toastWarning(t('toast.endedMeeting'));
            } else {
                toastError(t(TOAST_DEFAULT.ERROR));
            }
        })
        .catch((e) => {
            toastError(t(TOAST_DEFAULT.ERROR));
        })
        .finally(() => {
            setCloseDialogCC();
        });
    };

    const handleOpenDialogEndRoom = (roomId, parentRoomId) => {
        setOpenDialogCC({
            id: DIALOG_ID.CONFIRM,
            props: {
                title: t('room.pop-up.end.title'),
                contentText: t('room.pop-up.end.text1'),
                onClick: () =>  {actionEndRoom(roomId, parentRoomId)},
                isDisableLoadingButton: true
            }
        })
    }

    const checkLimitMeeting = () => {
        return apiManagerUser.checkLimitMeeting(parentRoomId || roomId)
    }

    const handleStartRoom = (e) => {
        e.stopPropagation();
        e.preventDefault()

        checkLimitMeeting()
            .then(res => {
                if(res?.startMeeting){
                    goToRoomMeeting(parentRoomId || roomId)
                }else{
                    if(res?.isHostMeeting){
                        setOpenDialogCC({ id: DIALOG_ID.LIMIT_TOTAL_MEETING_HOST })
                    }else{
                        setOpenDialogCC({ id: DIALOG_ID.LIMIT_TOTAL_MEETING })
                    }
                }
                // if(res?.isHostMeeting){
                //     if(res?.totalMeeting >= totalMeeting()){
                //         setOpenDialogCC({ id: DIALOG_ID.LIMIT_TOTAL_MEETING_HOST })
                //     }else {
                //         goToRoomMeeting(parentRoomId || roomId)
                //     }
                // }else{
                //     goToRoomMeeting(parentRoomId || roomId)
                // }
            })
            .catch(err => {
                console.log("err: ", err)
            })

    }

    const handleJoinRoomByRoomId = () => {
        checkLimitMeeting()
        .then(res => {

            if(res?.startMeeting){
                joinRoomByRoomId(parentRoomId || roomId)
            }else{
                if(res?.isHostMeeting){
                    setOpenDialogCC({ id: DIALOG_ID.LIMIT_TOTAL_MEETING_HOST })
                }else{
                    setOpenDialogCC({ id: DIALOG_ID.LIMIT_TOTAL_MEETING })
                }
            }
            // if(res?.isHostMeeting){
            //     if(res?.totalMeeting >= totalMeeting()){
            //         setOpenDialogCC({ id: DIALOG_ID.LIMIT_TOTAL_MEETING_HOST })
            //     }else{
            //         joinRoomByRoomId(parentRoomId || roomId)
            //     }
            // }else{
            //     joinRoomByRoomId(parentRoomId || roomId)
            // }
            
        })
        .catch(err => {
            console.log("err: ", err)
        })
    }

    return (
        <>{
            isListType ? (
                <Box sx={{ display: 'flex', alignItems: 'center' }} aria-label="item-list-day">
                    <Typography className="test" sx={{ display: { xs: 'none', md: 'flex' }, textTransform: 'capitalize', width: '150px', fontSize: '0.875em', fontWeight: 500 }}>{isToday ? `${t('dateOfWeek.Today')} ` : moment.unix(tsStart).format('dddd') + ' '}</Typography>
                    <Typography sx={{ display: { xs: 'none', sm: 'flex' }, fontSize: '0.875em', fontWeight: 500 }}>{moment.unix(tsStart).format('DD/MM/YYYY') + ' '}</Typography>
                    <TooltipCC title={t(LABEL_STATUS_MEETING_EVENT[status])}>
                        <Box sx={{ margin: { xs: '0', xl: `0 ${theme.spacing(2)}` }, width: '50px', display: 'flex', justifyContent: 'center' }}>
                            <Box sx={{ width: '16px', height: '16px', backgroundColor: COLOR_MEETING_EVENT[status], borderRadius: '50%', border: status === STATUS_MEETING_EVENT.NOT_START ? `2px solid ${theme.palette.primary.main}` : 0 }}></Box>
                        </Box>
                    </TooltipCC>
                    <Typography sx={{ display: { xs: 'none', sm: 'flex' }, marginRight: theme.spacing(2), fontSize: '0.875em', fontWeight: 500 }}>{start.format('HH:mm') + ' - ' + end.format('HH:mm')}</Typography>
                    <Typography onClick={() => copyToClipboard(roomId)} sx={{ cursor: 'pointer', display: { xs: 'none', md: 'flex' }, margin: { xs: `0 ${theme.spacing(2)} 0 0`, xl: `0 ${theme.spacing(2)}` }, fontSize: '0.875em', fontWeight: 500, '&:hover': { transform: 'scale(1.125)' } }}>{parentRoomId || roomId}</Typography>
                    <TitleMeetingEvent status={status} title={title} handleClickViewDetail={handleClickViewDetail} t={t} handleCopyRoomLink={handleCopyRoomLink} roomId={parentRoomId || roomId}/>
                    {(status === STATUS_MEETING_EVENT.NOT_START || (status === STATUS_MEETING_EVENT.ENDED && moment().unix() < endTimeCalendar ) || (isInstant === 1)) && <Button onClick={handleStartRoom} sx={{ display: { xs: 'none', sm: 'flex' }, marginLeft: theme.spacing(2.5) }}>{t('actions.start')}</Button>}
                    {status === STATUS_MEETING_EVENT.PROGRESS && <Button onClick={() => joinRoomByRoomId(parentRoomId || roomId)} sx={{ display: { xs: 'none', sm: 'flex' }, marginLeft: theme.spacing(2.5) }}>{t('actions.join')}</Button>}
                    {/* {status === STATUS_MEETING_EVENT.NOT_START && <Button onClick={() => handleUpdateRoom(tsStart, roomName)} sx={{ display: { xs: 'none', sm: 'flex' }, marginLeft: theme.spacing(2.5) }}>{t('actions.update')}</Button>} */}
                    {status === STATUS_MEETING_EVENT.PROGRESS && <Button onClick={() => handleOpenDialogEndRoom(roomId, parentRoomId)} variant="outlined" sx={{ display: { xs: 'none', sm: 'flex' }, marginLeft: theme.spacing(2.5) }}>{t('actions.finish')}</Button>}
                    <Button onClick={handleClickViewDetail} variant="outlined" className="btn-detail-meeting" sx={{ display: { xs: 'none', sm: 'flex' }, marginLeft: theme.spacing(2.5) }}>{t('actions.detail')}</Button>
                </Box>
            ) : (
                <div className={`event-content-wrapper ${isShortTime ? 'event-short-wrapper' : ''}`} style={{ borderRight: `4px solid ${BORDER_COLOR_RIGHT_MEETING_EVENT[status]}`, borderLeft: `4px solid ${COLOR_MEETING_GRID_EVENT[status]}` }}>
                    <div className='info-event-content'>
                        <span className='info-title-event' style={{ textDecoration: `${status === STATUS_MEETING_EVENT.CANCELED ? 'line-through' : 'unset'}` }}>{title}</span>
                        {!isShortTime && (
                            <>
                                <span className='info-time-event'>{start.format('HH:mm')} - {end.format('HH:mm')}</span>
                                <span className='info-roomId-event'>{isPeriod === "yes"? parentRoomId : roomId }</span>
                            </>
                        )}
                    </div>
                    {((status === STATUS_MEETING_EVENT.NOT_START || (status === STATUS_MEETING_EVENT.ENDED && moment().unix() < endTimeCalendar) || (isInstant === 1)) && role !== ROLE_IN_ROOM.PARTICIPANT) && (
                        isShortTime ? <IconJoinMeeting onClick={handleStartRoom} /> : <button onClick={handleStartRoom} className='event-btn-join'>{t('actions.start')}</button>
                    )}
                    {status === STATUS_MEETING_EVENT.PROGRESS && <button className='event-btn-join' onClick={() => handleJoinRoomByRoomId()}>{t('actions.join')}</button>}
                </div>
            )
        }</>
    )
}

/**
 * anhnt653 20230915
 * Handle render event list
 * Xử lý style border của các elements trong dạng list
 * @param {*} args 
 */
export function renderEventList(args) {
    const elms = document.querySelectorAll('.fc-event.fc-event-start.fc-event-end.fc-list-event')
    if (elms.length) {
        elms.forEach((e, index) => {
            if (e === args.el) {
                if (index % 2 === 0) {
                    args.el.childNodes[args.el.childElementCount - 1].style.borderBottomStyle = "dashed";
                    args.el.childNodes[args.el.childElementCount - 1].style.borderBottomWidth = "1px"
                } else {
                    args.el.childNodes[args.el.childElementCount - 1].style.borderTopStyle = "dotted";
                    args.el.childNodes[args.el.childElementCount - 1].style.borderTopWidth = "1px"
                }

                if (index === elms.length - 1) {
                    args.el.childNodes[args.el.childElementCount - 1].style.boxShadow = '0px 1px #ddd'
                }
            }
        })
    }
}

/**
 * anhnt653 20230915
 * Trả về giá trị contentHeight cho Schedule dựa trên giá trị truyền vào
 * @param {*} isListView Boolean 
 * @returns giá trị contentHeght
 */
export function getContentHeight(hasSearch = true, customID = []) {
    const heightManagerMeetingPage = getHeightElmById('#manager-meeting-page')
    const heightBreadCrumbs = getHeightElmById('#bread-crumbs')
    const heightSearchPage = hasSearch ? getHeightElmById('#search-page') : 0

    let customHeight = 0
    if (customID) {
        customID.forEach(id => {
            customHeight += getHeightElmById(id)
        })
    }

    return heightManagerMeetingPage - heightBreadCrumbs - heightSearchPage - 48 - customHeight
}

export function getHeightPage(customID = []) {
    const heightBreadCrumbs = getHeightElmById('#bread-crumbs')

    // let customHeight = 0
    // if (customID) {
    //     customID.forEach(id => {
    //         customHeight += getHeightElmById(id)
    //     })
    // }

    return window.innerHeight - parseInt(HEIGHT_COMPONENTS.HEADER) - heightBreadCrumbs
}

export function getHeightStatic(numberEl = 3) {
    return window.innerHeight - parseInt(HEIGHT_COMPONENTS.HEADER) - parseInt(HEIGHT_COMPONENTS.BREADCRUM) - (parseInt(HEIGHT_COMPONENTS.BREADCRUM) * numberEl)
}

export function getHeightElmById(id) {
    return window.document.querySelector(id)?.offsetHeight
}


/**
 * anhnt653 20230915
 * Đặt giá trị isTodayInView dựa vào giá trị đầu vào
 * @param {*} args 
 * @param {*} actions func thực hiện
 */
export function setIsTodayInCurrentView(args, actions) {
    // Lấy thông tin về phạm vi hiện tại
    const currentViewStart = args.start;
    const currentViewEnd = args.end;

    // Lấy ngày hiện tại
    const today = new Date();

    // Kiểm tra xem ngày hiện tại có nằm trong phạm vi hiện tại hay không
    const isTodayInView = today >= currentViewStart && today <= currentViewEnd;

    if (isTodayInView) {
        actions(true)
    } else {
        actions(false)
    }
}

function convertStatusMeeting({type, value}) {
    try {
        if(type === TYPE_CONVERT_MEETING.HISTORY) {
            switch (value) {
                case 2:            // Đã quá hạn
                    return STATUS_MEETING_EVENT.EXPIRED
                default: // Đã diễn ra CASE:( 0, 1 )
                    return STATUS_MEETING_EVENT.ENDED
            }
        } else {

            switch (value) {
                case "not_start":   // Sắp tới
                    return STATUS_MEETING_EVENT.NOT_START
                case "progress":    // Đang diễn ra
                    return STATUS_MEETING_EVENT.PROGRESS
                case 1:             // Đã diễn ra
                    return STATUS_MEETING_EVENT.CANCELED
                default:
                    return STATUS_MEETING_EVENT.CANCELED
            }
        }
    } catch (err) {
        console.log("convertStatusMeeting: ", err);
    }
}

/**
 * Lấy mã màu dựa treo trạng thái cuộc học để render event dạng tuần || ngày
 * @param {*} status 
 * @returns 
 */
export function getBackgroundColorEvent(status) {
    const canceledExpriedArray = [STATUS_MEETING_EVENT.CANCELED, STATUS_MEETING_EVENT.EXPIRED]
    
    try {
        if (canceledExpriedArray.includes(status)) return BACKGROUNDCOLOR_MEETING_EVENT.EXP_END
        return isDefaultColorSystem() ? BACKGROUNDCOLOR_MEETING_EVENT.DEFAULT : getCurrentColorSystem().P2
    } catch (err) {
        console.log("err", err);
    }
}

export function convertEventMeeting(data) {
    if (!data) return []
    try {
        data = data.map(event => {
            const timeDuration = moment.unix(event.tsEnd).diff(moment.unix(event.tsStart), 'minutes')
            return {
                id: `${event?.roomId}-${event?.start}`,
                title: event.roomName,
                start: timeDuration > 30 ? moment.unix(event.tsStart).format() : moment.unix(event.tsEnd).subtract(30, 'minutes').format(),
                end: moment.unix(event.tsEnd).format(),
                backgroundColor: getBackgroundColorEvent(convertStatusMeeting((event?.historyStatus === 0 || event?.historyStatus === 1 || event?.historyStatus === 2) ? {type: TYPE_CONVERT_MEETING.HISTORY, value: event?.historyStatus} : {type: TYPE_CONVERT_MEETING.DEFAULT, value: event?.isTrash || event?.type})),
                extendedProps: {
                    roomId: event?.roomId,
                    title: event.roomName,
                    start: moment.unix(event.tsStart),
                    end: moment.unix(event.tsEnd),
                    tsStart: event.tsStart,
                    tsEnd: event.tsEnd,
                    endTimeCalendar: event.endTimeCalendar,
                    isInstant: event.isInstant,
                    status: convertStatusMeeting((event?.historyStatus === 0 || event?.historyStatus === 1 || event?.historyStatus === 2) ? {type: TYPE_CONVERT_MEETING.HISTORY, value: event?.historyStatus} : {type: TYPE_CONVERT_MEETING.DEFAULT, value: event?.isTrash || event?.type}),
                    parentRoomId: event?.parentRoomId,
                    realRoomId: event?.realRoomId,
                    roomName: event?.roomName,
                    isPeriod: event?.isPeriod,
                    role: event?.role || ROLE_IN_ROOM.OWNER
                }
            }
        })
        return data
    } catch (err) {
        console.log("convertEventMeeting: ", err);
    }
}